import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import UserDatabases from '@Services/UserDatabases';

function ExportModalHeader(props) {
  const { parentParams, close } = props;
  const { context, databaseId } = parentParams;

  const showBioLabel = context === 'dpitems' || context === 'tgitems';
  const isDbNameVisible = UserDatabases.getAll().length > 1;
  const dbName = UserDatabases.getDbName(databaseId);
  const closeLabel = 'Close export modal';

  return (
    <div className="exportModal__header">
      <h3 className="u-els-font-size-h3 u-els-line-height-single">
        Export
        {!showBioLabel && (
          <>
            <span className="text-lowercase">{context}</span>
            {isDbNameVisible && <span>{dbName}</span>}
          </>
        )}
        {showBioLabel && <span className="text-lowercase">Substances and Bioactivities</span>}
      </h3>
      <ButtonWithIcon
        data-e2e="export-modal-close"
        type="link"
        size="small"
        sprite="Close"
        iconOnly
        aria-label={closeLabel}
        onClick={close}>
        {closeLabel}
      </ButtonWithIcon>
    </div>
  );
}

ExportModalHeader.propTypes = {
  parentParams: PropTypes.object,
  close: PropTypes.func,
};

export default ExportModalHeader;
